import { Box, Button, IconButton, MobileStepper } from '@mui/material';
import { EastRounded, WestRounded } from '@mui/icons-material';
import SwipeableViews from 'react-swipeable-views';
import theme from '../../../../theme';
import MediaInfoCard from './MediaInfoCard';
import { SKIP_BUTTON } from '../../../../constants';
import { IIntroductoryCarouselViewProps } from '../../../../constants/types';
import { styles } from './style';

const IntroductoryCarouselView = ({
  activeStep,
  steps,
  maxSteps,
  handleNext,
  handleBack,
  handleSkip,
}: IIntroductoryCarouselViewProps) => (
  <Box
    className="d-flex flex-column flex-1"
    sx={{ bgcolor: 'primary.main', p: 3 }}
  >
    <Box
      className="d-flex flex-column align-items-center flex-1"
      pt={9.25}
      pb={4.5}
    >
      <Button
        variant="text"
        sx={{
          minWidth: 'fit-content',
          color: 'common.white',
          textDecoration: 'none',
        }}
        className="align-self-end"
        onClick={handleSkip}
      >
        {SKIP_BUTTON}
      </Button>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleNext}
        enableMouseEvents
        className="w-100 flex-1"
      >
        {steps.map(({ description, image, label }, index) => (
          <Box key={label} className="d-flex flex-column">
            {Math.abs(activeStep - index) <= 2 && (
              <MediaInfoCard
                key={`mediaCard-${label}`}
                description={description}
                image={image}
                label={label}
              />
            )}
          </Box>
        ))}
      </SwipeableViews>
      <MobileStepper
        sx={styles.mobileStepper}
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        className="w-100"
        nextButton={
          <IconButton
            sx={styles.iconButton}
            aria-label="next"
            size="large"
            onClick={handleNext}
          >
            {theme.direction === 'rtl' ? (
              <WestRounded color="primary" />
            ) : (
              <EastRounded color="primary" />
            )}
          </IconButton>
        }
        backButton={
          <IconButton
            sx={styles.iconButton}
            aria-label="previous"
            size="large"
            onClick={handleBack}
            disabled={activeStep === 0}
          >
            {theme.direction === 'rtl' ? (
              <EastRounded color="primary" />
            ) : (
              <WestRounded color="primary" />
            )}
          </IconButton>
        }
      />
    </Box>
  </Box>
);

export default IntroductoryCarouselView;
